import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import DiagnosesSwitcher from './../../components/DiagnosesSwitcher/DiagnosesSwitcher';
import { isAnorexiaDiagnosis } from './../../helpers/DiagnosesHelper';
import * as actionTypes from './../../store/actions/diagnosesAction';
import fetchDiagnosesAction from './../../store/actions/fetch/fetchDiagnosesAction';
import Loader from './../../components/Loader/Loader'

import * as productsActionTypes from './../../store/actions/productsAction';
import * as criticalCareActionTypes from './../../store/actions/criticalCareAction';

/**
 * Diagnoses container
 */
class Diagnoses extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  handleDiagnosisSelect = (id) => {
    const {resetSelectedProducts, onSelect, onSelectAnorexia, onSelectCriticalCare,
      isWeightAdjustmentSelected, data} = this.props;

    // Handle anorexia diagnosis selection
    if (isAnorexiaDiagnosis(data, id)) {
      // Prevent anorexia selection when weight adjustment is active
      if (isWeightAdjustmentSelected) {
        return;
      }

      onSelectCriticalCare(true);
      onSelectAnorexia(true);
    }

    resetSelectedProducts();
    onSelect(id);
  }

  render() {
    const { data, error, pending, selected, defaultValues, ready } = this.props;
    // If there is a need for default data
    if(!ready && !error && !pending) {
      defaultValues();
    }
    // If is pending
    if(pending || !ready) return (
      <Loader/>
    );
    // Return switcher
    return (
      <div className='nppe2-fc-diagnoses-switcher__wrapper'>
        {error && <span className='nppe2-fc-diagnoses-switcher__error'>{error}</span>}
        {!error &&
        <DiagnosesSwitcher
          data={data}
          selected={selected}
          onSelect={this.handleDiagnosisSelect}
        />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selected: state.diagnosesReducer.selected,
    error: state.diagnosesReducer.error,
    data: state.diagnosesReducer.data,
    pending: state.diagnosesReducer.pending,
    ready: state.diagnosesReducer.ready,
    isWeightAdjustmentSelected: state.weightAdjustmentReducer.selected,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchDiagnosesAction
      },
      dispatch,
    ),
    onSelect: (id) => dispatch({
      type: actionTypes.SELECT,
      selected: id,
    }),
    resetSelectedProducts: () => dispatch({
      type: productsActionTypes.RESET_PRODUCTS,
    }),
    onSelectCriticalCare: (val) => dispatch({
      type: criticalCareActionTypes.SELECT,
      selected: val,
    }),
    onSelectAnorexia: (val) => dispatch({
      type: criticalCareActionTypes.SELECT_ANOREXIA,
      selected: val,
    }),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Diagnoses);

